import React from 'react';
import { Box, Typography } from '@mui/material';
import { InboxOutlined } from '@mui/icons-material';
import { useLanguage } from '../context/LanguageContext';

const EmptyState = ({ message, icon: Icon = InboxOutlined, subtitle }) => {
  const { t } = useLanguage();
  const displayMessage = message || t('noData');

  return (
    <Box
      sx={{
        p: 4,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        minHeight: 200,
        color: 'text.secondary',
      }}
    >
      <Icon sx={{ fontSize: 44, color: 'text.secondary', opacity: 0.4, mb: 1.5 }} />
      <Typography variant="subtitle2" sx={{ fontWeight: 700, color: 'text.primary', mb: 0.5 }}>
        {displayMessage}
      </Typography>
      {subtitle && (
        <Typography variant="caption" color="text.secondary">
          {subtitle}
        </Typography>
      )}
    </Box>
  );
};

export default EmptyState;
